import React, { useContext } from 'react';
import CuoreOut from '../../assets/icone/card/IconaPreferiti.svg';
import CuoreFill from '../../assets/icone/card/iconaPreferitiFill.svg';
import { FavoritesContext } from '../../context/FavoritesContext';
import { AuthContext } from '../../context/authContext';
import api from '../../api';
import { showToast } from '../toast/ToastNotifier';

const FavoriteButton = ({ itemId, type }) => {
    const { favoriteIds, setFavoriteIds } = useContext(FavoritesContext);
    const { isAuthenticated } = useContext(AuthContext);
    const isFavorite = favoriteIds.has(itemId);

    const toggleFavorite = async () => {
        if (!isAuthenticated) {
            showToast.error('Devi essere loggato per modificare i preferiti!');
            return; // Non chiamiamo l'API, quindi niente loader
        }

        try {
            let response;
            if (isFavorite) {
                // Rimuovi dai preferiti
                response = await api.delete(`/reservations/${type}/${itemId}/favorites`, {
                    skipLoading: true, // <--- Salta il caricamento
                    customToastMessage: "Rimosso dai preferiti con successo!",
                    errorToastMessage: "Errore durante la rimozione dai preferiti",
                });
            } else {
                // Aggiungi ai preferiti
                response = await api.put(
                    `/reservations/${type}/${itemId}/favorites`,
                    {}, // Dati (eventualmente vuoto)
                    {
                        skipLoading: true, // <--- Salta il caricamento
                        customToastMessage: "Aggiunto ai preferiti con successo!",
                        errorToastMessage: "Errore durante l'aggiunta ai preferiti",
                    }
                );
            }

            // Se l'operazione è andata a buon fine, aggiorna lo stato locale
            if (response.status === 200) {
                const newFavorites = new Set(favoriteIds);
                if (isFavorite) {
                    newFavorites.delete(itemId);
                } else {
                    newFavorites.add(itemId);
                }
                setFavoriteIds(newFavorites);
            }
        } catch (error) {
        }
    };

    return (
        <button onClick={toggleFavorite} className="bg-white rounded-full lg:p-4 p-4">
            {isFavorite ? (
                <img src={CuoreFill} alt="Favorite" className="w-6 sm:w-6" />
            ) : (
                <img src={CuoreOut} alt="Not Favorite" className="w-6 sm:w-6" />
            )}
        </button>
    );
};

export default FavoriteButton;
